// the .env file in the frontend is read during bundling
// important: only variables starting with REACT_APP are accepted

const appName = process.env.REACT_APP_NAME
const appVersion = process.env.REACT_APP_VERSION

const appApi = process.env.REACT_APP_API
const appMaxFileSize = process.env.REACT_APP_MAX_FILE_SIZE;

export const config = {
    appName,
    appVersion,
    appApi,
    appMaxFileSize
}

export default config
